import type { Transaction } from '@shared/transactions-types';
import { createMutation, request } from '@luna/api';
import { logger } from '@luna/logger';
import { t } from '@luna/i18n';

import { updateTransactionCache } from '../list/PaginatedTransactions';
import { getAttachmentUrl } from './getAttachmentUrl';

export const [useRemoveAttachment] = createMutation({
    name: 'transactions/removeAttachment',
    payloadCreator: (transaction: Transaction): Promise<Transaction> =>
        request
            .delete<void>(getAttachmentUrl(transaction.id))
            .then(() => {
                const attachment = null;
                const updatedTransaction: Transaction = { ...transaction, attachment };
                updateTransactionCache(updatedTransaction);
                return updatedTransaction;
            })
            .catch((error) => {
                logger.error(error);
                throw new Error(t('transaction.attachment.deleteError'));
            }),
});
